import { render, staticRenderFns } from "./processRecord.vue?vue&type=template&id=644003e3&scoped=true&"
import script from "./processRecord.vue?vue&type=script&lang=js&"
export * from "./processRecord.vue?vue&type=script&lang=js&"
import style0 from "./processRecord.vue?vue&type=style&index=0&id=644003e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644003e3",
  null
  
)

export default component.exports